module.exports = __webpack_public_path__ + "static/media/screenshot9.9998c32b.png";